import { c as _c } from "react/compiler-runtime";
import { Tooltip, Typography } from "@mui/material";
import React from "react";
import { useI18nContext } from "#/shared/hooks";
type NewLabelProps = {
  createdAt: string;
};
export const NewLabel: React.FC<NewLabelProps> = t0 => {
  const $ = _c(12);
  const {
    createdAt
  } = t0;
  const {
    LL
  } = useI18nContext();
  let t1;
  if ($[0] !== createdAt) {
    t1 = typeof createdAt === "string" ? new Date(createdAt) : createdAt;
    $[0] = createdAt;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const date = t1;
  let t2;
  if ($[2] !== date) {
    t2 = date.toLocaleString();
    $[2] = date;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const t3 = `Created at ${t2}`;
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      display: "inline-block",
      fontSize: 12,
      px: 0.5,
      pt: 0.1,
      height: "1.2rem",
      opacity: 0.9,
      color: "white",
      backgroundColor: "success.main",
      borderRadius: 2,
      boxShadow: 4
    };
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== LL) {
    t5 = LL.NEW();
    $[5] = LL;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t5) {
    t6 = <Typography variant="caption" sx={t4}>{t5}</Typography>;
    $[7] = t5;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== t3 || $[10] !== t6) {
    t7 = <Tooltip title={t3} arrow={true}>{t6}</Tooltip>;
    $[9] = t3;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  return t7;
};